import { useNavigate, useParams } from "react-router-dom";
import { componentState } from "../../../../atoms/componentState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useState } from "react";
import { Box, Button, Flex } from "@chakra-ui/react";

import { FaBackward } from "react-icons/fa";
import { GRAY, WHITE } from "../../../../constants/colors";
import { LISTAGEMVENDASRECORRENTES } from "../../../../constants/paths";
import TableSalesListTransacoes from "./tableSalesListTransacoes";
import { customColors } from "../../../../atoms/customColors";

export default function ListagemTransacoesVendasRecorrentes() {
  const setHeaderLocation = useSetRecoilState(componentState);
  setHeaderLocation("Transações");
  const navigate = useNavigate();

  const colors = useRecoilState(customColors)[0];

  const { id } = useParams();

  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [search, setSearch] = useState("");
  const dataInicio = filtros.initialDateFilter;
  const dataFim = filtros.finalDateFilter;

  const [disable, setDisable] = useState(false);
  return (
    <Flex flexDir={"column"} height="100%" width="100%">
      <Box
        width={"99.8%"}
        bgColor={colors.WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.2%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex
          justifyContent={"space-between"}
          flexDirection={"row"}
          my={"auto"}
          px={8}
        >
          <Box w={"22%"}>
            <Button
              leftIcon={<FaBackward />}
              style={{ color: "white" }}
              onClick={() => {
                navigate(LISTAGEMVENDASRECORRENTES);
              }}
              _hover={{ bg: "#4B4B57" }}
              bgColor={colors.GRAY}
            >
              Voltar a Lista de Assinaturas
            </Button>
          </Box>
        </Flex>
      </Box>
      <Box
        w={"99.8%"}
        height={"80vh"}
        bgColor={colors.WHITE}
        mt={"0.5%"}
        shadow={"md"}
        mx="auto"
        py={3}
        px={3}
      >
        <TableSalesListTransacoes
          search={search}
          dataInicio={dataInicio}
          dataFim={dataFim}
          filtros={filtros}
          idCustomer={id}
        />
      </Box>
    </Flex>
  );
}
